import { Link } from "react-router-dom";
import { Figure } from "../Figure";
import { useFeaturedPublishedEvents } from "../../lib/publishedEvents";
import { useHomeLimits } from "../../lib/homeLimits";
import { ROUTES } from "../../lib/routes";

/**
 * Wired and featured only: webadmin's own `featured` records, nothing else.
 * The hand-picked local slug list this rail used to fall back on is
 * retired — see publishedEvents.ts for why this specific hook skips the
 * content-quality guards usePublishedEvents() applies everywhere else. The
 * newest first, up to webadmin's home `maxEvents`.
 *
 * section--flush: it follows Campus Life on the same background, so that
 * section's bottom padding is the gap and this one adds none above itself.
 */
export function Events() {
  const { maxEvents } = useHomeLimits();
  const events = useFeaturedPublishedEvents().slice(0, maxEvents);
  if (events.length === 0) return null;

  return (
    <section className="section section--flush">
      <div className="container">
        <div className="section-head">
          <div>
            <div className="kicker">What's happening</div>
            <h2>Campus Events</h2>
          </div>
          <Link className="btn-link" to={ROUTES.events}>
            All events <span className="arr">→</span>
          </Link>
        </div>
        <div className="events-grid">
          {events.map((e) => (
            <Link key={e.slug} to={`${ROUTES.events}/${e.slug}`} className="event-card reveal">
              <Figure media={e.media} fallbackLabel={e.hero} aspect="16/10" sizes="(max-width: 900px) 100vw, (max-width: 1100px) 48vw, 23vw" />
              <div className="event-body">
                <div className="event-meta">
                  <span className="event-tag">{e.tag}</span>
                  <span className="event-date">{e.dateLine}</span>
                </div>
                <h4>{e.title}</h4>
                <div className="event-venue">
                  {e.venue}
                  {e.time ? ` · ${e.time}` : ""}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
